var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MPInstancesHub } from "@/api/RequestAxios/RequestAxiosHub";
import { packPartnerSelfOnboarding, packSignupPayload, unpackServerLogin, unpackSignUp } from "./auth.mapper";
import { UIModelLogin } from "./auth.model";
import config from "@/config";
import { MPInstanceAuthX360 } from "@/api/RequestAxios/RequestAxiosAuthX360";
import MPStorage from "@/services/LocalStorage";
import { getUtmQueryString } from "@/utilities/utm";
import { customKeys } from "@/services/LocalStorage/LocalStorage";
var fetchSocialLoginUrl = function () { return "/token_from_facebook"; };
var fetchResetPasswordUrl = function () { return "/dbconnections/change_password"; };
var embeddedSignUp = function (_a) {
    var partnerId = _a.partnerId;
    return "/public/partners/".concat(partnerId, "/register_client");
};
var authX360LoginUrlWithOrgName = function (orgName) {
    return "".concat(config.authX360UrlV1, "/login?app_name=").concat(config.appName, "&organization=").concat(orgName.toLowerCase(), "&env=").concat(config.authX360Env);
};
var encodeEmailForUrl = function (email) {
    return email.replace(/\+/g, "%2B").replace(/ /g, "%20");
};
/**
 * authx360 accepts utm_source/medium/campaign/term/content on /login, remembers them for
 * the duration of the signup and attaches them to signup_completed. This redirect is the
 * ONLY place they can be captured -- the Auth0 signup webhook carries no campaign data --
 * so without them signup_completed.utm_* stays permanently empty.
 *
 * getUtmQueryString reads the values itself rather than taking them from each caller:
 * loginViaAuth360 is invoked from many places (401 handling, logout recovery, the signup
 * form) and every one of them wants the same values. Appended on the login branch as well
 * as signup, because a partner who arrives on a campaign link and logs in is the same
 * acquisition.
 */
export var authX360LoginUrl = function (_a) {
    var prompt = _a.prompt, flow = _a.flow, email = _a.email, _b = _a.isPartnerSignup, isPartnerSignup = _b === void 0 ? false : _b;
    return "".concat(config.authX360UrlV1, "/login?app_name=").concat(isPartnerSignup ? config.appNamePartner : config.appName, "&env=").concat(config.authX360Env).concat(prompt ? "&prompt=".concat(prompt) : "").concat(flow ? "&flow=".concat(flow) : "").concat(email ? "&login_hint=".concat(encodeEmailForUrl(email)) : "").concat(getUtmQueryString());
};
var authX360LogoutUrl = function () {
    return "".concat(config.authX360UrlV1, "/logout?app_name=").concat(config.appName, "&env=").concat(config.authX360Env);
};
var checkPermissionsUrl = function () { return "/authorization/check"; };
var selfOnboardingUrl = function () { return "/partners/register_partner"; };
export var fetchSocialLogin = function (payload) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(fetchSocialLoginUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, new UIModelLogin(unpackServerLogin(data))];
        }
    });
}); };
export var fetchResetPassword = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.auth0Api.post(fetchResetPasswordUrl(), payload)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var signUp = function (_a) {
    var partnerId = _a.partnerId, payload = _a.payload;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(embeddedSignUp({ partnerId: partnerId }), packSignupPayload(payload))];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, unpackSignUp(data)];
            }
        });
    });
};
export var getCannySSOToken = function () { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.get("/canny/sso_token")];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getUsers = function (params) { return __awaiter(void 0, void 0, Promise, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.get("users", {
                    params: params
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var checkPermissions = function (_a) {
    var permission = _a.permission, entityId = _a.entityId;
    return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, MPInstanceAuthX360.buffedInstances.post(checkPermissionsUrl(), { entity_id: entityId, permission: permission })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var loginViaAuth360 = function (query, orgName) {
    if (query === void 0) { query = { prompt: false }; }
    MPStorage.removeFromLS(customKeys.AUTH360_ERROR);
    var loginUrl = !orgName
        ? authX360LoginUrl(query)
        : authX360LoginUrlWithOrgName(orgName);
    window.location.href = loginUrl;
};
export var logoutViaAuth360 = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                MPStorage.saveToLocalStorage(customKeys.IS_LOGGING_OUT, "true");
                window.location.href = authX360LogoutUrl();
                return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export function getToken() {
    return __awaiter(this, void 0, void 0, function () {
        var tokenUrl, response, authorization, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tokenUrl = config.authX360UrlV1 + "/token";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(tokenUrl, {
                            method: "HEAD",
                            credentials: "include"
                        })];
                case 2:
                    response = _a.sent();
                    authorization = response.headers.get("X-Authx360-Access-Token");
                    return [2 /*return*/, authorization];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error fetching token:", error_1);
                    // Fix: Check if error.response exists and has status property
                    if (error_1.response && error_1.response.status === 401) {
                        logoutViaAuth360();
                        return [2 /*return*/];
                    }
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function partnerSelfOnboarding(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, MPInstancesHub.buffedInstances.newCrm.post(selfOnboardingUrl(), packPartnerSelfOnboarding(payload))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, unpackSignUp(data)];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aEh1Yi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImF1dGhIdWIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLG9DQUFvQyxDQUFDO0FBQ3BFLE9BQU8sRUFDTCx5QkFBeUIsRUFDekIsaUJBQWlCLEVBQ2pCLGlCQUFpQixFQUNqQixZQUFZLEVBQ2IsTUFBTSxlQUFlLENBQUM7QUFHdkIsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUM1QyxPQUFPLE1BQU0sTUFBTSxVQUFVLENBQUM7QUFFOUIsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0seUNBQXlDLENBQUM7QUFHN0UsT0FBTyxTQUFTLE1BQU0seUJBQXlCLENBQUM7QUFDaEQsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFDcEQsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLHNDQUFzQyxDQUFDO0FBR2xFLElBQU0sbUJBQW1CLEdBQUcsY0FBTSxPQUFBLHNCQUFzQixFQUF0QixDQUFzQixDQUFDO0FBQ3pELElBQU0scUJBQXFCLEdBQUcsY0FBTSxPQUFBLGdDQUFnQyxFQUFoQyxDQUFnQyxDQUFDO0FBQ3JFLElBQU0sY0FBYyxHQUFHLFVBQUMsRUFBb0M7UUFBbEMsU0FBUyxlQUFBO0lBQ2pDLE9BQUEsMkJBQW9CLFNBQVMscUJBQWtCO0FBQS9DLENBQStDLENBQUM7QUFDbEQsSUFBTSwyQkFBMkIsR0FBRyxVQUFDLE9BQWU7SUFDbEQsT0FBQSxVQUFHLE1BQU0sQ0FBQyxhQUFhLDZCQUNyQixNQUFNLENBQUMsT0FBTywyQkFDQyxPQUFPLENBQUMsV0FBVyxFQUFFLGtCQUFRLE1BQU0sQ0FBQyxXQUFXLENBQUU7QUFGbEUsQ0FFa0UsQ0FBQztBQUNyRSxJQUFNLGlCQUFpQixHQUFHLFVBQUMsS0FBYTtJQUN0QyxPQUFPLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDLE9BQU8sQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDMUQsQ0FBQyxDQUFDO0FBQ0Y7Ozs7Ozs7Ozs7O0dBV0c7QUFDSCxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRyxVQUFDLEVBVWhDO1FBVEMsTUFBTSxZQUFBLEVBQ04sSUFBSSxVQUFBLEVBQ0osS0FBSyxXQUFBLEVBQ0wsdUJBQXVCLEVBQXZCLGVBQWUsbUJBQUcsS0FBSyxLQUFBO0lBT3ZCLE9BQUEsVUFBRyxNQUFNLENBQUMsYUFBYSw2QkFDckIsZUFBZSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsT0FBTyxrQkFDbEQsTUFBTSxDQUFDLFdBQVcsU0FBRyxNQUFNLENBQUMsQ0FBQyxDQUFDLGtCQUFXLE1BQU0sQ0FBRSxDQUFDLENBQUMsQ0FBQyxFQUFFLFNBQzVELElBQUksQ0FBQyxDQUFDLENBQUMsZ0JBQVMsSUFBSSxDQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsU0FDMUIsS0FBSyxDQUFDLENBQUMsQ0FBQyxzQkFBZSxpQkFBaUIsQ0FBQyxLQUFLLENBQUMsQ0FBRSxDQUFDLENBQUMsQ0FBQyxFQUFFLFNBQUcsaUJBQWlCLEVBQUUsQ0FBRTtBQUpqRixDQUlpRixDQUFDO0FBQ3BGLElBQU0saUJBQWlCLEdBQUc7SUFDeEIsT0FBQSxVQUFHLE1BQU0sQ0FBQyxhQUFhLDhCQUFvQixNQUFNLENBQUMsT0FBTyxrQkFBUSxNQUFNLENBQUMsV0FBVyxDQUFFO0FBQXJGLENBQXFGLENBQUM7QUFDeEYsSUFBTSxtQkFBbUIsR0FBRyxjQUFNLE9BQUEsc0JBQXNCLEVBQXRCLENBQXNCLENBQUM7QUFDekQsSUFBTSxpQkFBaUIsR0FBRyxjQUFNLE9BQUEsNEJBQTRCLEVBQTVCLENBQTRCLENBQUM7QUFFN0QsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUcsVUFDOUIsT0FBaUMscUNBQ2hDLE9BQU87Ozs7b0JBRU4scUJBQU0sY0FBYyxDQUFDLGVBQWUsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUM5QyxtQkFBbUIsRUFBRSxFQUNyQixPQUFPLENBQ1IsRUFBQTs7Z0JBSkssSUFBSSxHQUNWLENBQUEsU0FHQyxDQUFBLEtBSlM7Z0JBS1osc0JBQU8sSUFBSSxZQUFZLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBQzs7O0tBQ2xELENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxrQkFBa0IsR0FBRyxVQUFPLE9BQTRCOzs7O29CQUNsRCxxQkFBTSxjQUFjLENBQUMsZUFBZSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQ2pFLHFCQUFxQixFQUFFLEVBQ3ZCLE9BQU8sQ0FDUixFQUFBOztnQkFITyxJQUFJLEdBQUssQ0FBQSxTQUdoQixDQUFBLEtBSFc7Z0JBSVosc0JBQU8sSUFBSSxFQUFDOzs7S0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLFVBQU8sRUFNNUI7UUFMQyxTQUFTLGVBQUEsRUFDVCxPQUFPLGFBQUE7Ozs7O3dCQUtVLHFCQUFNLGNBQWMsQ0FBQyxlQUFlLENBQUMsTUFBTSxDQUFDLElBQUksQ0FDL0QsY0FBYyxDQUFDLEVBQUUsU0FBUyxXQUFBLEVBQUUsQ0FBQyxFQUM3QixpQkFBaUIsQ0FBQyxPQUFPLENBQUMsQ0FDM0IsRUFBQTs7b0JBSE8sSUFBSSxHQUFLLENBQUEsU0FHaEIsQ0FBQSxLQUhXO29CQUtaLHNCQUFPLFlBQVksQ0FBQyxJQUFJLENBQUMsRUFBQzs7OztDQUMzQixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUcsK0NBQVUsT0FBTzs7OztvQkFDOUIscUJBQU0sY0FBYyxDQUFDLGVBQWUsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUU3RCxrQkFBa0IsQ0FBQyxFQUFBOztnQkFGZCxJQUFJLEdBQUssQ0FBQSxTQUVLLENBQUEsS0FGVjtnQkFJWixzQkFBTyxJQUFJLEVBQUM7OztLQUNiLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxRQUFRLEdBQUcsVUFDdEIsTUFBdUIscUNBQ3RCLE9BQU87Ozs7b0JBRU4scUJBQU0sa0JBQWtCLENBQUMsZUFBZSxDQUFDLEdBQUcsQ0FDMUMsT0FBTyxFQUNQO29CQUNFLE1BQU0sUUFBQTtpQkFDUCxDQUNGLEVBQUE7O2dCQU5LLElBQUksR0FDVixDQUFBLFNBS0MsQ0FBQSxLQU5TO2dCQU9aLHNCQUFPLElBQUksRUFBQzs7O0tBQ2IsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLFVBQU8sRUFNdEM7UUFMQyxVQUFVLGdCQUFBLEVBQ1YsUUFBUSxjQUFBO3FDQUlOLE9BQU87Ozs7d0JBQ1EscUJBQU0sa0JBQWtCLENBQUMsZUFBZSxDQUFDLElBQUksQ0FFM0QsbUJBQW1CLEVBQUUsRUFBRSxFQUFFLFNBQVMsRUFBRSxRQUFRLEVBQUUsVUFBVSxZQUFBLEVBQUUsQ0FBQyxFQUFBOztvQkFGdEQsSUFBSSxHQUFLLENBQUEsU0FFNkMsQ0FBQSxLQUZsRDtvQkFJWixzQkFBTyxJQUFJLEVBQUM7Ozs7Q0FDYixDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sZUFBZSxHQUFHLFVBQzdCLEtBS3FCLEVBQ3JCLE9BQWdCO0lBTmhCLHNCQUFBLEVBQUEsVUFLTSxNQUFNLEVBQUUsS0FBSyxFQUFFO0lBR3JCLFNBQVMsQ0FBQyxZQUFZLENBQUMsVUFBVSxDQUFDLGFBQWEsQ0FBQyxDQUFDO0lBRWpELElBQU0sUUFBUSxHQUFHLENBQUMsT0FBTztRQUN2QixDQUFDLENBQUMsZ0JBQWdCLENBQUMsS0FBSyxDQUFDO1FBQ3pCLENBQUMsQ0FBQywyQkFBMkIsQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUV6QyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUM7QUFDbEMsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUc7Ozs7Z0JBQzlCLFNBQVMsQ0FBQyxrQkFBa0IsQ0FBQyxVQUFVLENBQUMsY0FBYyxFQUFFLE1BQU0sQ0FBQyxDQUFDO2dCQUNoRSxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxpQkFBaUIsRUFBRSxDQUFDO2dCQUMzQyxxQkFBTSxJQUFJLE9BQU8sQ0FBQyxVQUFDLE9BQU8sSUFBSyxPQUFBLFVBQVUsQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQXpCLENBQXlCLENBQUMsRUFBQTs7Z0JBQXpELFNBQXlELENBQUM7Ozs7S0FDM0QsQ0FBQztBQUVGLE1BQU0sVUFBZ0IsUUFBUTs7Ozs7O29CQUN0QixRQUFRLEdBQUcsTUFBTSxDQUFDLGFBQWEsR0FBRyxRQUFRLENBQUM7Ozs7b0JBRTlCLHFCQUFNLEtBQUssQ0FBQyxRQUFRLEVBQUU7NEJBQ3JDLE1BQU0sRUFBRSxNQUFNOzRCQUNkLFdBQVcsRUFBRSxTQUFTO3lCQUN2QixDQUFDLEVBQUE7O29CQUhJLFFBQVEsR0FBRyxTQUdmO29CQVNJLGFBQWEsR0FBRyxRQUFRLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyx5QkFBeUIsQ0FBQyxDQUFDO29CQUN0RSxzQkFBTyxhQUFhLEVBQUM7OztvQkFFckIsT0FBTyxDQUFDLEtBQUssQ0FBQyx1QkFBdUIsRUFBRSxPQUFLLENBQUMsQ0FBQztvQkFDOUMsOERBQThEO29CQUM5RCxJQUFJLE9BQUssQ0FBQyxRQUFRLElBQUksT0FBSyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFO3dCQUNuRCxnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixzQkFBTztxQkFDUjtvQkFDRCxzQkFBTyxJQUFJLEVBQUM7Ozs7O0NBRWY7QUFFRCxNQUFNLFVBQWdCLHFCQUFxQixDQUFDLE9BQStCOzs7Ozt3QkFDeEQscUJBQU0sY0FBYyxDQUFDLGVBQWUsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUMvRCxpQkFBaUIsRUFBRSxFQUNuQix5QkFBeUIsQ0FBQyxPQUFPLENBQUMsQ0FDbkMsRUFBQTs7b0JBSE8sSUFBSSxHQUFLLENBQUEsU0FHaEIsQ0FBQSxLQUhXO29CQUtaLHNCQUFPLFlBQVksQ0FBQyxJQUFJLENBQUMsRUFBQzs7OztDQUMzQiJ9